import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "wishlist--sprite",
  "use": "wishlist--sprite-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"wishlist--sprite\">\n  <path d=\"M27 11.888A5.882 5.882 0 0 0 21.124 6c-1.972 0-3.697.986-4.758 2.482a.45.45 0 0 1-.73 0C14.573 6.986 12.848 6 10.878 6A5.882 5.882 0 0 0 5 11.888c-.01 5.443 8.981 12.81 10.713 14.178a.46.46 0 0 0 .574 0C18.02 24.698 27.01 17.331 27 11.888z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol